export default "__VITE_ASSET__yhlMry0O__"